import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import packageJson from '../package.json'
import { Amplify, Hub, Auth } from 'aws-amplify';
import { environment } from './amplifyConfiguration';

Amplify.configure(environment.cognitoConfiguration);

let urn = "";
let idToken = "";

Hub.listen('auth', async (data) => {
  
  if (data.payload.event === "signIn") {
    await Auth.currentAuthenticatedUser();
  }
})


ReactDOM.render(
	<App version={packageJson.version} dateModified={packageJson.dateModified} urn={urn} idToken={idToken} />
	, document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister(); 
